// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getAuth,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDPBNZrw7oCHzTHbURl990--XQWlRLxkBg",
    authDomain: "guestbook-personal.firebaseapp.com",
    projectId: "guestbook-personal",
    storageBucket: "guestbook-personal.appspot.com",
    messagingSenderId: "950022605967",
    appId: "1:950022605967:web:4ad31820f650cadcbd74fa"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);